import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MicrosoftFilledSvg = function MicrosoftFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2 5.08 8.173-1.109.004 7.86-8.17.046zm8.17 7.656.006 7.867-8.17-1.12v-6.8zm.99-8.91 10.837-1.577v9.482l-10.837.085zM22 12.81l-.003 9.439-10.837-1.525-.015-7.931z"
  }));
};
export var MicrosoftFilled = function MicrosoftFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MicrosoftFilledSvg
  }));
};